import { Play } from "lucide-react";

export const hasVideo = (r) =>
  (r?.interviews || []).some((v) => v?.url) || (r?.video_gallery || []).filter(Boolean).length > 0;

export const videoCount = (r) =>
  (r?.interviews || []).filter((v) => v?.url).length + (r?.video_gallery || []).filter(Boolean).length;

// Superposition "vignette vidéo" à placer dans un conteneur `relative` (cover d'une carte).
export default function VideoBadge({ r }) {
  if (!hasVideo(r)) return null;
  const n = videoCount(r);
  return (
    <>
      <span className="absolute inset-0 flex items-center justify-center pointer-events-none" data-testid="video-badge">
        <span className="h-14 w-14 rounded-full bg-black/45 backdrop-blur-sm flex items-center justify-center ring-2 ring-white/70 shadow-lg transition-transform duration-300 group-hover:scale-110">
          <Play size={22} className="text-white translate-x-0.5" fill="currentColor" />
        </span>
      </span>
      <span className="absolute bottom-3 right-3 inline-flex items-center gap-1 rounded-full bg-black/60 backdrop-blur-sm px-2.5 py-1 text-[11px] font-semibold text-white">
        <Play size={11} fill="currentColor" /> {n} vidéo{n > 1 ? "s" : ""}
      </span>
    </>
  );
}
